import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '../hooks/useScrollAnimation';
const categories = [{
  title: 'Strategic Leadership',
  items: ['Enterprise Digital Transformation', 'Board & Executive Communication', 'M&A Technology Due Diligence', 'P&L Ownership & Budget Management', 'Organizational Design & Scaling', 'Vendor & Partner Management']
}, {
  title: 'Infrastructure & Cloud',
  items: ['Hybrid Cloud Architecture', 'Multi-Cloud Strategy (AWS, Azure, GCP)', 'Infrastructure Modernization', 'DevOps & Site Reliability Engineering', 'Kubernetes & Container Orchestration', 'Edge Computing & Network Architecture']
}, {
  title: 'Security & Compliance',
  items: ['Zero-Trust Security Frameworks', 'Regulatory Compliance (SOC 2, PCI DSS, HIPAA)', 'Cyber Resiliency & Incident Response', 'FedRAMP & NIST CSF Implementation', 'Risk Management & Governance', 'Identity & Access Management']
}, {
  title: 'Data & Emerging Technology',
  items: ['AI/ML Platform Engineering', 'Data Architecture & Engineering', 'MLOps & Model Deployment at Scale', 'API Strategy & Integration', 'Digital Product Development', 'Technology Innovation Programs']
}];
export function CompetenciesSection() {
  return <section id="competencies" className="py-20 md:py-32 bg-dark-bg border-t border-dark-border/30" data-id="element-105">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-106">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} data-id="element-107">
          <motion.div variants={fadeInUp} className="mb-16" data-id="element-108">
            <span className="font-sans text-gold/80 tracking-widest uppercase text-xs font-semibold mb-2 block" data-id="element-109">
              Core Competencies
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-110">
              Areas of Expertise
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-111">
            {categories.map((cat, i) => <motion.div key={i} variants={fadeInUp} className="bg-dark-card border border-dark-border rounded-xl p-8" data-id="element-112">
                <h3 className="text-white font-bold text-lg mb-5 pb-4 border-b border-dark-border" data-id="element-113">
                  {cat.title}
                </h3>
                <ul className="space-y-3" data-id="element-114">
                  {cat.items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-115">
                      <span className="w-1 h-1 rounded-full bg-gold/60 mt-2 flex-shrink-0" data-id="element-116"></span>
                      <span className="text-slate-300 text-sm leading-relaxed" data-id="element-117">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}